<template>
  <div class="animated fadeIn">
    <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
    <b-card v-else>
      <template v-slot:header>
        <h5>Blacklist Rekening</h5>
      </template>
      <div class="search-wrapper d-flex align-items-center justify-content-between">
        <b-form-group label="Filter" label-for="filterInput" class="form-inline form-group-wrapper mb-3">
          <div class="d-flex search-input-wrapper">

            <b-form-input class="mx-2" v-model="filters.noRekening" name="filterTable" id="filterInput"
              placeholder="No. Rekening" @keyup.enter="onFilter"></b-form-input>

            <b-form-select class="mr-2" v-model="filters.regarding" :options="perihalOpt" value-field="id"
              text-field="name">
              <template v-slot:first>
                <b-form-select-option :value="null">Semua Perihal</b-form-select-option>
              </template>
            </b-form-select>

            <b-button class="mr-2" variant="pgiBtn" :disabled="isBusy" name="searchTableBtn" @click="onFilter">
              <i class="fa fa-search"></i>
            </b-button>
            <b-button variant="pgiBtn" name="reseFilterBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
          </div>
        </b-form-group>
        <b-button class="mb-3" variant="pgiBtn" name="dataAddBtn" @click="inputBlacklist">Tambah
          Blacklist</b-button>
      </div>
      <b-table bordered hover show-empty :busy="isBusy" :items="data" :fields="fields" :no-local-sorting="false"
        responsive class="mb-3">
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Loading data...</strong>
          </div>
        </template>
        <template v-slot:empty>
          Tidak ada data.
        </template>
        <template v-slot:cell(createdBy)="row">
          {{ row.item.createdBy }}, {{ $helper.changeDateFormat(row.item.createdAt) }} {{
            $helper.changeDateFormatGetHour(row.item.createdAt) }}
        </template>
        <template v-slot:cell(action)="row">
          <b-button class="btn btn-sm mr-2" v-b-tooltip.hover title="Hapus Data" variant="danger"
            @click="modalDelete(row.item.id)">
            <i class="fa fa-trash"></i>
          </b-button>
        </template>
      </b-table>

      <div class="pagination-wrapper d-flex align-items-center justify-content-between">
        <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
          <b-form-select v-model="show" id="showItems" :options="optionsLimit" @change="onLimitChange">
            <template v-slot:first>
              <b-form-select-option :value="null" disabled />
            </template>
          </b-form-select>
          <span class="ml-2">{{ totalViewText }}</span>
        </b-input-group>
        <b-pagination class="mb-0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" aria-controls="my-table"
          @input="onPageChange"></b-pagination>
      </div>

      <b-modal id="modal-input-blacklist" title="Input Blacklist" no-close-on-backdrop>
        <div>
          <label>No. Rekening</label>
          <b-form-input class="mr-2" v-model="form.noRekening" name="noRekening" id="noRekening"
            placeholder="No. Rekening..." maxlength="100"></b-form-input>
        </div>
        <div class="my-2">
          <label>Perihal</label>
          <multiselect v-model="form.regarding" :options="perihalOpt" :internal-search="true" :allow-empty="false"
            deselect-label="" select-label="" label="name" track-by="id" placeholder="-- Please select an option --" />
        </div>
        <div class="my-2">
          <label>Alasan</label>
          <b-form-textarea class="mr-2" v-model="form.reason" name="alasan" id="alasan" placeholder="Alasan..." rows="4"
            maxlength="255"></b-form-textarea>
        </div>

        <template v-slot:modal-footer="{ cancel }">
          <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
            Tutup
          </b-button>
          <b-button variant="pgiBtn" :disabled="loading" name="closeDetailBtn" @click="confirmSubmit()">
            {{ loading ? 'Loading...' : 'Submit' }}
          </b-button>
        </template>
      </b-modal>

      <ModalConfirm id="confirm-input-blacklist" title="Konfirmasi Tambah" :isSubmitting="isLoadingAdd"
        desc="Apakah anda yakin untuk menambah Data ini ?" @submit="onSubmit" />

      <ModalConfirm id="modal-delete" title="Konfirmasi Hapus Data" :isSubmitting="isLoadingDelete"
        desc="Apakah anda yakin untuk hapus Data ini ?" @submit="onDelete" />

    </b-card>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'

export default {
  data() {
    return {
      initStatus: 0,
      isBusy: true,
      filters: {
        noRekening: '',
        regarding: null,
      },
      form: {
        noRekening: '',
        reason: '',
        regarding: null,
      },
      fields: [
        { key: "noRekening", label: "No. Rekening" },
        { key: "regarding", label: "Perihal" },
        { key: "reason", label: "Alasan" },
        { key: "createdBy", label: "Dibuat Oleh / Pada" },
        { key: "action", label: "Aksi" },
      ],
      data: [
        {
          "id": "BLK-2026-001",
          "noRekening": "0082741933",
          "regarding": "Indikasi Fraud",
          "reason": "Laporan berkala dari banyak user terkait modus penipuan marketplace.",
          "createdBy": "Admin_Compliance_01",
          "createdAt": "2026-01-20T09:15:00Z"
        },
        {
          "id": "BLK-2026-002",
          "noRekening": "5410982210",
          "regarding": "Money Laundering",
          "reason": "Transaksi mencurigakan di luar profil nasabah (STR Report).",
          "createdBy": "System_Auto_Flag",
          "createdAt": "2026-01-21T14:30:22Z"
        },
        {
          "id": "BLK-2026-003",
          "noRekening": "1228839405",
          "regarding": "Permintaan Otoritas",
          "reason": "Surat resmi Kepolisian No: B/123/I/2026/Reskrim.",
          "createdBy": "Legal_Dept_Head",
          "createdAt": "2026-01-22T10:05:45Z"
        },
        {
          "id": "BLK-2026-004",
          "noRekening": "7700192834",
          "regarding": "Phishing Activity",
          "reason": "Rekening penampung dana dari link palsu perbankan.",
          "createdBy": "Cyber_Security_Team",
          "createdAt": "2026-01-23T08:12:10Z"
        },
        {
          "id": "BLK-2026-005",
          "noRekening": "0022334455",
          "regarding": "Identitas Palsu",
          "reason": "Temuan dokumen KYC tidak valid/pemalsuan KTP.",
          "createdBy": "KYC_Analyst_05",
          "createdAt": "2026-01-23T16:45:00Z"
        }
      ],
      currentPage: 1,
      show: 10,
      perPage: 10,
      totalRows: 0,
      totalPages: 0,
      totalViewText: "",
      optionsLimit: CONSTANTS.OPTIONS_LIMIT_PAGINATION,
      perihalOpt: [],
      isLoadingAdd: false,
      isLoadingDelete: false
    }
  },
  methods: {
    init() {
      this.initStatus = 1
      this.getItems()
    },

    getItems() {
      this.isBusy = false
    },

    onLimitChange() {

    },

    onPageChange() {

    },

    onReset() {

    },

    onFilter() {

    },

    inputBlacklist() {
      this.$bvModal.show('modal-input-blacklist')
    },

    confirmSubmit() {

    },

    onSubmit() {

    },

    modalDelete() {

    },

    onDelete() {

    },
  },

  created() {
    this.init()
  }
}
</script>
